export default {
  type: "string",
  description: "Access token",
  example: "ey...sRo"
};
